import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: '[Testimonial în curând - locuri rezervate pentru feedback-ul participanților]',
  name: '[Nume Client]',
  role: '[Ocupație]'
}, {
  quote: '[Testimonial în curând - locuri rezervate pentru feedback-ul participanților]',
  name: '[Nume Client]',
  role: '[Ocupație]'
}, {
  quote: '[Testimonial în curând - locuri rezervate pentru feedback-ul participanților]',
  name: '[Nume Client]',
  role: '[Ocupație]'
}];
export const Testimonials = () => {
  return <section className="py-24 bg-[#111936] relative" data-id="element-248">
      <div className="container mx-auto px-6" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-250">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-251">
            Ce spun oamenii care au lucrat cu noi
          </h2>
          <div className="w-24 h-px bg-gold mx-auto mt-8" data-id="element-252" />
        </motion.div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-253">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-navy p-8 relative" data-id="element-254">
              <Quote className="w-12 h-12 text-gold/20 absolute top-6 right-6" data-id="element-255" />
              <div className="flex items-center gap-4 mb-6" data-id="element-256">
                <div className="w-12 h-12 rounded-full bg-navy-card border border-gold/30 flex items-center justify-center" data-id="element-257">
                  <span className="font-display text-gold text-sm font-bold" data-id="element-258">
                    {test.name.charAt(1) || 'C'}
                  </span>
                </div>
                <div data-id="element-259">
                  <h4 className="font-serif text-lg font-bold text-white" data-id="element-260">
                    {test.name}
                  </h4>
                  <p className="font-display text-xs text-textSub uppercase tracking-wider" data-id="element-261">
                    {test.role}
                  </p>
                </div>
              </div>
              <p className="font-sans text-textLight/90 italic leading-relaxed" data-id="element-262">
                "{test.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};